import { Directive, HostBinding } from '@angular/core';
import { FormControl, NgControl } from "@angular/forms";

@Directive({
    selector: '[bootstrapValidation]',
    standalone: true
})
export class BootstrapValidationDirective {

  constructor(private control: NgControl) { }

  @HostBinding('class.is-invalid')
  get invalid() {
    return this.control.touched && !this.control.valid;
  }

  public showError(control: FormControl) {
    return control.invalid && control.touched;
  }

}
